import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

export default {

  init() {
    const sliders = this;
    console.log('init sliders...');

    $(function() {
      sliders.sliders();
    });
  },

  sliders() {

    // Home slider
    var home = document.querySelectorAll('.slider--home');

    if(home.length) {

      // Home taglines
      new Splide('.slider--home', {
        type       : 'loop',
        autoWidth  : true,
        arrows     : false,
        pagination : false,
        focus      : 'center',
        autoScroll: {
          speed: 0.2,
        },
        mediaQuery : 'min',
        breakpoints: {
          1280: {
            destroy: true,
          }
        }
      }).mount({ AutoScroll });

    }

    // Standard sliders
    var elems = document.querySelectorAll('.slider--cards');

    if(elems.length) {
      elems.forEach(function(elem) {
        new Splide( elem, {
          type       : 'loop',
          perPage    : 1,
          autoWidth  : true,
          arrows     : true,
          pagination : true,
          mediaQuery : 'min',
          trimSpace  : false,
          breakpoints: {
            768: {
              perPage: 2,
            },
            1024: {
              perPage: 3,
            },
          },
          arrowPath: 'm12.3535534 0 10 10 .3535534.3535534-10.3535534 10.3535534-.7071068-.7071068 9.1465534-9.147-20.793.0005534v-1.00000001l20.793-.00055339-9.1465534-9.14589321z',
          classes: {
            arrows    : 'splide__arrows btn-group',
            arrow     : 'splide__arrow btn',
            prev      : 'splide__arrow--prev btn btn-left',
            next      : 'splide__arrow--next btn btn-right',
            pagination: 'splide__pagination', // container
            page      : 'splide__pagination__page', // each button
          },
        }).mount();
      });
    }

    // Single sliders
    var elems = document.querySelectorAll('.slider--full');

    if(elems.length) {
      elems.forEach(function(elem) {
        new Splide( elem, {
          type       : 'loop',
          perPage    : 1,
          autoWidth  : true,
          arrows     : true,
          pagination : true,
          trimSpace  : false,
          arrowPath: 'm12.3535534 0 10 10 .3535534.3535534-10.3535534 10.3535534-.7071068-.7071068 9.1465534-9.147-20.793.0005534v-1.00000001l20.793-.00055339-9.1465534-9.14589321z',
          classes: {
            arrows    : 'splide__arrows btn-group',
            arrow     : 'splide__arrow btn',
            prev      : 'splide__arrow--prev btn btn-left',
            next      : 'splide__arrow--next btn btn-right',
            pagination: 'splide__pagination', // container
            page      : 'splide__pagination__page', // each button
          },
        }).mount();
      });
    }

  }

};
